module.exports = __webpack_public_path__ + "img/newance-logo.feaa0e9a.svg";